// extracted by mini-css-extract-plugin
module.exports = {"verifyEmailContainer":"VerifyEmail_verifyEmailContainer__kEBkZ"};